/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import { initialState } from './defaultState';
import { setImportResponse, setIsImporterLoading } from './actions';

const importReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setIsImporterLoading, (state, action) => {
      state.isLoading = action.payload.isLoading;
    })
    .addCase(setImportResponse, (state, action) => {
      state.response = action.payload.response;
    });
});

export default importReducer;
